import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'
import { CreatePlaylistDTO, Playlist } from './playlistsSlice'

type MoodId = string
interface State {
  moods: Record<MoodId, PlaylistFolder>
}
export interface CreateFolderDTO {
  title: string
  image: string
}

export type EditFolderDTO = CreateFolderDTO & {
  _id: PlaylistFolder['_id']
}

export enum FolderOrderBy {
  TITLE = 'title',
}

export interface GetFoldersListDto extends GetListDTO {
  oderBy?: FolderOrderBy
}

export interface PlaylistFolder {
  title: string
  image: string
  _id: string
}

export const initialState: State = {
  moods: {},
}
export const attemptCreateMood = createAsyncThunk<PlaylistFolder, CreateFolderDTO>(
  'moods/mood-create',
  async (payload) => {
    const response = await $api.post(`moods/create`, payload)
    return response.data
  },
)

export const attemptGetMoodsList = createAsyncThunk<PlaylistFolder[], GetFoldersListDto>(
  'moods/list',
  async (payload) => {
    const response = await $api.post('moods/admin/list', payload)
    console.log('attemptGetMoodsList response.data:', response.data)
    return response.data
  },
)

export const attemptGetMood = createAsyncThunk<PlaylistFolder, string>(
  'moods/get-mood',
  async (id) => {
    const response = await $api.post(`moods/get/${id}`)
    return response.data
  },
)

export const attemptEditMood = createAsyncThunk<void, EditFolderDTO>(
  'moods/mood-edit',
  async (payload) => {
    const response = await $api.post(`moods/update/${payload._id}`, payload)
    console.log('attemptEditMood response.data:', response.data)
    // return response.data
    return
  },
)

export const attemptDeleteMood = createAsyncThunk<
  PlaylistFolder['_id'],
  PlaylistFolder['_id']
>('moods/mood-delete', async (playlistId) => {
  await $api.post(`moods/delete/${playlistId}`)
  return playlistId
})

export const moodsReducer = createSlice({
  name: 'moods',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptCreateMood.fulfilled, (state, { payload }) => {
      // state.moods[payload._id] = payload //don't need it as we are always fetching moods when coming to the page
    })
    builder.addCase(attemptGetMoodsList.fulfilled, (state, { payload }) => {
      payload.forEach((playlist) => {
        state.moods[playlist._id] = playlist
      })
    })
    builder.addCase(attemptDeleteMood.fulfilled, (state, { payload: _id }) => {
      delete state.moods[_id]
    })
  },
})

export const {} = moodsReducer.actions
export default moodsReducer.reducer
